<template>
    <div style="height: 100%;width: 100%;overflow: hidden">
      <div class="nothing-data" v-if="cityData.length === 0"></div>
      <div v-else class="bg-base">
        <div style="height: 100%;width: 100%;" id="pie2" ref="pie_wrap2"></div>
      </div>
    </div>
</template>

<script>
import HighCharts from 'highcharts'
export default {
  name: 'indexCity',
  props: {
    AlarmCountWithZone: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      cityData: [
        // ['区域一', 10],
        // ['区域二', 5],
        // ['区域三', 20],
        // ['区域四', 4]
      ],
      ZoneAlarmArr: [],
      isShow: false
    }
  },
  created () {
    // 区域报警占比
    this.ZoneAlarmArr = this.AlarmCountWithZone
    this.getStartData()
  },
  mounted () {
    this.getPieData()
    this.isShow = true
  },
  methods: {
    getRefresh (arr) {
      // console.log('全市报警趋势')
      this.cityData = []
      this.ZoneAlarmArr = arr
      this.getStartData()
    },
    getStartData () {
      // console.log('全市报警趋势1', this.ZoneAlarmArr)
      let arr1 = []
      for (let i = 0; i < this.ZoneAlarmArr.length; i++) {
        if (this.ZoneAlarmArr[i].alarmcount > 0) {
          let arr = []
          arr.push(this.ZoneAlarmArr[i].zonename)
          arr.push(this.ZoneAlarmArr[i].alarmcount)
          arr1.push(arr)
        }
      }
      // console.log('全市', arr1)
      this.cityData = arr1
      if (this.isShow) {
        // console.log('全市1')
        this.getPieData()
      }
    },
    // pie
    getPieData () {
      if (this.cityData.length === 0) {
        // console.log('return')
        return
      }
      // console.log('HighCharts')
      HighCharts.chart('pie2', {
        title: false,
        chart: {
          backgroundColor: '#00000000',
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 65
          }
        },
        plotOptions: {
          pie: {
            innerSize: 45,
            depth: 35,
            dataLabels: {
              enabled: true
            }
          }
        },
        /* 去logo */
        credits: {
          enabled: false
        },
        series: [
          {
            name: '警报数量',
            data: this.cityData
            // colors: ['rgba(0, 174, 255, 0.9)', 'rgba(255, 29, 29,0.9)', 'rgba(22,38,255,0.9)', 'rgba(249,175,26,0.9)',
            //   'rgba(255, 109, 130, 0.9)', 'rgba(171, 109, 255, 0.9)', 'rgba(110, 255, 148, 0.9)', 'rgba(229, 229, 23, 0.9)']
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
  .bg-base{
    width: 100%;
    height: 100%;
  }
  .bg-base1{
    position: relative;
    width: 230px;
    height: 100px;
    top: 50%;
    margin-top: -30px;
    left: 50%;
    margin-left: -116px;
    text-align: center;
    background: url("../../../assets/SHscreen/pie_base.png") no-repeat bottom;
    background-size: 85% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/monitoring/bigComponents/indexCity.vue